<template>
    <div class="product_area" style="overflow: visible">
        <main-right-popup-common ref="mainRightPopupCommon" :titleName="'我的询价'">
            <template v-slot:typeDiv>
                <div class="radioBox">
                    <el-radio v-model="myLineInquiry" :label="1" @change="getListData('empty')">我的线路询价</el-radio>
                    <el-radio v-model="myLineInquiry" :label="2" @change="getListData('empty')">我的项目询价</el-radio>
                    <el-radio v-model="myLineInquiry" :label="3" @change="getListData('empty')">我的产品询价</el-radio>
                    <el-radio v-model="myLineInquiry" :label="4" @change="getListData('empty')">客户询价</el-radio>
                </div>
            </template>
            <template v-slot:searchDiv>
                <div class="centerBox">
                    <div class="centerBox-top">
                        <el-input placeholder="计划出行的目的地" prefix-icon="el-icon-search" size="medium"
                                  style="width:1.5rem"></el-input>
                        <el-input placeholder="计划出行年/月" prefix-icon="el-icon-search" size="medium"
                                  style="width:1.5rem"></el-input>
                        <el-input v-model="inquiryId" placeholder="询单号" prefix-icon="el-icon-search" size="medium"
                                  style="width:1.5rem"></el-input>
                        <el-autocomplete :clearable="true" :popper-append-to-body="false" placeholder="制作人"
                                         size="mini"
                                         style="width:1.5rem"></el-autocomplete>
                        <span class="searchBtn" @click="getListData('empty')">搜索</span>
                    </div>
                    <div class="centerBox-button">
                        <div class="centerBox-leftBox">
                            <div v-if="myLineInquiry!=4" class="centerBox planNumber" style="padding:0;">
                                <el-input v-model="planNumberSea" class="planSearch" placeholder="团号"
                                          prefix-icon="el-icon-search" size="medium"
                                          style="width:1.5rem;padding-top: 0.07rem;"></el-input>
                            </div>
                            <div v-if="myLineInquiry===2">
                                <ul>
                                    <li :class="checkresouceType.length===stockTypes.length?'checkedLi':''"
                                        @click="onlySeeOneType()">全部
                                    </li>
                                    <li v-for="(name,ind) in stockTypes" :key="ind" :class="checkresouceType.indexOf(name.index)!==-1?'checkedLi':''"
                                        @click="onlySeeOneType(name.index)">
                                        {{ name.name }}
                                    </li>
                                </ul>
                            </div>
                            <div class="btnList">
                                <span :class="isCustomizerSend===0?'checkSpan':''" class="btn">全部</span>
                                <span :class="isCustomizerSend===1?'checkSpan':''" class="btn">已经收到的回复</span>
                                <span :class="isCustomizerSend===2?'checkSpan':''" class="btn">尚未收到的回复</span>
                                <span class="btn">我预定的</span>
                            </div>
                        </div>
                        <div class="centerBox-rightBox">
                            <div class="card">
                                <span class="num">{{ myInquiryListTotal }}</span>
                                <span class="tag">您询价的数量</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:dataDiv>
                <div v-for="(item,index) in informationList" :key="index">
                    <inquiryInfo :item="item" :myLineInquiry="myLineInquiry" 
                        @showProgramListTwo="showProgramListTwo" @zhaunxun="zhaunxun" @getInquiryLog="getInquiryLog"></inquiryInfo>
                    <div v-show="item.showMore" class="program_list">
                        <div v-if="myLineInquiry==2||myLineInquiry==4">
                            <exclusive-stock v-for="(dd,ii) in item.inquiryProductData" :key="ii" :butName="myLineInquiry==2?'加入报价':butName"
                                             :keyStr="key"
                                             :productObj="dd"></exclusive-stock>
                        </div>
                        <div v-if="myLineInquiry==1">
                            <div v-for="(item1,index1) in item.programList" :key="index1">
                                <plan-list-info :index="index1" :item="item1" :planId="0" :showDelete="false"
                                                @copyPlan="copyPlan"
                                                @replaceStroke="replaceStroke"></plan-list-info>
                            </div>
                        </div>
                        <div style="text-align:right;">
                            <i class="el-icon-arrow-up"
                               style="font-size:25px;color:#E64A19;font-weight:bold;line-height:25px;cursor:pointer;"
                               @click="item.showMore=false"></i>
                        </div>
                    </div>
                </div>
            </template>
        </main-right-popup-common>
        <el-dialog :append-to-body="true" :visible.sync="dialogVisible" title="行程展示" width="30%">
            <div class="Item-File">
                <div>
                    <Qr :text="text"></Qr>
                </div>
                <div>
                    <el-radio-group v-model="itemFileType" class="Export-Item-Radio-Download" @change="versionExport">
                        <el-radio v-for="(item,index) in itemFileTypeArr" :key="index" :label="item.value"
                                  style="width: 230px">
                            <i class="el-icon-upload"></i>
                            <span style="font-size: 12px !important;" v-html="item.name "></span>
                            <span v-if="itemFileType === item.value" class="checked">
                <i class="el-icon-loading" style="position: absolute;font-weight: 700;top: 10px;left: -25px"></i>
              </span>
                        </el-radio>
                    </el-radio-group>
                    <span
                        style="    display: flex;justify-content: center;margin-top: 5px;">手机扫描左侧二维码查看行程版本</span>
                </div>
            </div>
            <div style="display: flex;justify-content: center;margin-top: 10px;">
                <el-button type="primary" @click="sendPlan">预览方案</el-button>
                <el-button type="primary" @click="copyPlan(checkBudget)">复制方案</el-button>
            </div>
        </el-dialog>
        <H5PlanIframe ref="h5PlanIframe"></H5PlanIframe>
        <InquiryOpration ref="inquiryOpration"></InquiryOpration>
    </div>
</template>

<script>
import Api from '@/components/Api/index.js'
import PlanApi from '@/components/Api/PlanApi.js'
import mainRightPopupCommon from '../mainRightPopupCommon.vue'
import ExclusiveStock from '../stockPage/exclusiveStock.vue'
import planListInfo from '../trip/child/planListInfo.vue'
import {getPlanInfo, getOrderPlanInfo} from '../../js/function'
import H5PlanIframe from "@/components/H5PlanIframe.vue";
import Qr from "@/components/Qr.vue";
import InformationInquiryInfo from './informationInquiryInfo.vue'
import InquiryOpration from './inquiryOpration.vue'
import inquiryInfo from './inquiryInfo.vue'

export default {
    components: {mainRightPopupCommon, ExclusiveStock, planListInfo, Qr, H5PlanIframe, InformationInquiryInfo,
        InquiryOpration,inquiryInfo
    },
    data() {
        return {
            myLineInquiry: 1,
            stockTypes: [
                {"index": 0, name: '酒'},
                {"index": 1, name: '会'},
                {"index": 2, name: '景'},
                {"index": 3, name: '车'},
                {"index": 15, name: '交'},
                {"index": 4, name: '餐'},
                {"index": 5, name: '导'},
                {"index": 6, name: '签'},
                {"index": 7, name: '商'},
                {"index": 8, name: '特'},
                {"index": 9, name: '服'},
            ],
            inquiryId: null,
            planNumberSea: null,
            checkresouceType: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 15],
            isCustomizerSend: 0,
            informationProductPage: 1,
            informationList: [],
            myInquiryListTotal: 0,
            resouceTypeObj: {
                0: "酒店",
                1: "会议",
                2: "景点",
                3: "用车",
                4: "用餐",
                5: "导游",
                6: "签证",
                7: "商务",
                8: "特色体验",
                9: "服务",
                10: "交通",
            },
            key: null,
            dialogVisible: false,
            itemFileTypeArr: [
                {
                    name: `请点击此处下载<span style="color: #339900">word</span>版本`,
                    value: 0
                },
                {
                    name: '请点击此处下载<span style="color: #339900">pdf</span>版本',
                    value: 1
                }
            ],
            itemFileType: -1,
            checkBudget: {},
            text: '',
            butName: '加价'
        }
    },
    mounted() {
        this.getListData('empty')
        this.$Bus.$on('toInquiryPage', (index = 2) => {
            this.planNumberSea = this.$store.state.planId
            this.getListData('empty',index)
        })
    },
    beforeDestroy() {
        this.$Bus.$off("toInquiryPage");
    },
    methods: {
        getInquiryLog(item){
            this.$refs.inquiryOpration.openDialog(item.inquiryId)
        },
        versionExport(e) {
            this.itemFileType = e
            this.allowExport()
        },
        allowExport() {
            let fileSuffix = '.pdf'
            if (this.itemFileType === 0) {
                fileSuffix = ".docx"
            }
            let fileName = "团组报价单";
            if (this.checkBudget.budgetMain.shareSet && this.checkBudget.budgetMain.shareSet != '') {
                var obj = JSON.parse(this.checkBudget.budgetMain.shareSet)
                new PlanApi("plan").exportPlanToWord(this.checkBudget.budgetMain.id, obj.schemeRadio, fileName, this.itemFileType, obj,
                    fileSuffix, (e) => {
                        if (e) {
                            this.itemFileType = -1
                        }
                    })
            }
        },
        sendPlan() {
            if (this.text) {
                this.$refs.h5PlanIframe.open(this.text)
                let doc = document.getElementsByClassName("planWordDialog")[0]
                doc.style.left = "25% !important"
                this.left = "25%"
            }
        },
        onlySeeOneType(type) {
            if (type === 0 || type) {
                if (this.checkresouceType.indexOf(type) != -1) {
                    this.checkresouceType.splice(this.checkresouceType.indexOf(type), 1)
                } else {
                    this.checkresouceType.push(type)
                }
                this.getListData("empty")
            } else {
                if (this.checkresouceType.length === this.stockTypes.length) {
                    this.checkresouceType = [];
                    this.informationList = [];
                } else {
                    this.checkresouceType = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                    this.getListData("empty")
                }
            }
        },
        getListData(type, myLineInquiry) {
            if (myLineInquiry) {
                this.myLineInquiry = myLineInquiry
            }
            this.$refs.mainRightPopupCommon.loading = true
            if (type == 'empty') {
                this.informationProductPage = 1;
                this.informationList = []
            }
            if (this.myLineInquiry == 2) {
                new Api('inquiry').projectInquiryList({
                    page: this.informationProductPage,
                    size: 20,
                    q: {
                        id: this.inquiryId,
                        planId: this.planNumberSea,
                        resourceTypes: this.checkresouceType,
                        inquiryType: 0
                    }
                }).then(res => {
                    this.postSuccess(res)
                })
            } else if (this.myLineInquiry == 1) {
                new Api('inquiry').informationInquiryList({
                    page: this.informationProductPage,
                    size: 20,
                    q: {}
                }).then(res => {
                    this.postSuccess(res)
                })
            } else if (this.myLineInquiry == 4) {
                new Api('inquiry').userProjectInquiryList({
                    page: this.informationProductPage,
                    size: 20,
                    q: {
                        id: this.inquiryId,
                        resourceTypes: this.checkresouceType,
                        inquiryType: 0
                    }
                }).then(res => {
                    this.postSuccess(res)
                })
            }
        },
        postSuccess(res) {
            this.$refs.mainRightPopupCommon.loading = false
            if (res.status == 200) {
                if (res.data.records.length < 20) this.$refs.mainRightPopupCommon.isMore = true
                res.data.records.forEach(element => {
                    this.$set(element, 'showMore', false)
                });
                this.informationList = [...this.informationList, ...res.data.records]
                this.myInquiryListTotal = res.data.total
                if (this.informationList == this.myInquiryListTotal) this.$refs.mainRightPopupCommon.isMore = true
            } else {
                this.$message({type: "error", message: res.statusText})
            }
        },
        zhaunxun(item) {
            new Api('inquiry').userToInquiry({inquiryId: item.inquiryId}).then(res => {
                if (res.status == 200) {
                    this.$message({type: "success", message: '转询成功'})
                    this.getListData('empty')
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        showProgramListTwo(item) {
            new Api('resource').projectInquiryStockListNew({
                inquiryId: item.inquiryId,
                stockType: 2,
                state: item.resourceType,
                orderFlowDirection: this.myLineInquiry == 2 ? -2 : 3,
            }).then(res => {
                if (res.status == 200) {
                    res.data.forEach(e => {
                        this.$set(e, "isOpen", false)
                        this.$set(e, "fromInquiryId", item.inquiryId)
                        e.stockListResults.forEach(stock => {
                            if (stock.isOrder && stock.isOrder == 1) {
                                this.butName = '已定'
                            } else {
                                stock.priceList.forEach(pp => {
                                    if (pp.toCPrice&&pp.toCPrice != 0) {
                                        this.butName = '已加入行程'
                                    }
                                })
                            }
                            if (e.stockListResults.length == 1) {
                                this.$set(stock, "checkBox", true)
                            } else {
                                this.$set(stock, "checkBox", false)
                            }
                        })
                    })
                    this.$set(item, 'inquiryProductData', res.data)
                    this.$set(item, 'showMore', true)
                    this.key = res.key
                    new Api('inquiry').addReadNumber({
                        inquiryId: item.inquiryId,
                        key: this.key,
                    }).then(res => {
                    })
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        handlePlanList(res) {
            res.data.records.forEach(element => {
                this.$set(element, 'showIndex', 0)
                element.budgetMains.forEach(item => {
                    var str = item.planName.split(' ')
                    if (str.length == 1) {
                        this.$set(item, 'planName', '')
                        this.$set(item, 'planName1', str[0])
                    } else {
                        var planName = ""
                        str.forEach((item1, index) => {
                            if (index != str.length - 1) {
                                planName += item1 + " "
                            }
                        })
                        this.$set(item, 'planName', planName)
                        this.$set(item, 'planName1', str[str.length - 1])
                    }
                })
            });
        },
        showPlanListTwo(item, item1) {
            this.$set(item, 'showMore', true)
            new PlanApi('plan').planList({page: 1, size: 10, q: {informationId: item.inquiryId}}).then(res => {
                if (res.status == 200) {
                    this.handlePlanList(res)
                    this.$set(item, "programList", res.data.records);
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        copyPlan(item) {
            this.$confirm('您确定要将该方案复制到自己的行程轴吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                new PlanApi('plan').chooseOtherTrip({
                    oldId: item.budgetMains[item.showIndex].id,
                    oldPlanId: item.budgetMains[item.showIndex].planId,
                    imageKey: item.createName,
                    imageUrl: item.createIamgeUrl,
                }).then(res => {
                    if (res.status == 200) {
                        this.$message({type: "success", message: "采用成功"})
                        this.$store.commit('setPlanId', res.data.planId)
                        this.dialogVisible = false
                        getPlanInfo(res.data.planId, null)
                        getOrderPlanInfo(this.$store.state.planId, null)
                    } else {
                        this.$message({type: "error", message: res.statusText})
                    }
                })
            }).catch((err) => {
            })
        },
        replaceStroke(item, itemThree) {
            this.dialogVisible = true
            this.checkBudget = item
            if (item.budgetMain.shareSet && item.budgetMain.shareSet != '') {
                let jsonObj = JSON.parse(item.budgetMain.shareSet);
                let uri = process.env["VUE_APP_COLLECTION_H5_SERVE"]
                uri = uri + `?programmeId=${jsonObj.schemeRadio}&type=1&budgetMainId=${item.budgetMain.id}&planId=${item.id}&priceDisplay=${encodeURIComponent(item.budgetMain.shareSet)}`
                console.log("二维码链接", uri, jsonObj)
                this.text = uri
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.radioBox {
    display: flex;
    align-items: center;
    width: 6rem;

    /deep/ .el-radio__input {
        transform: scale(0.9);
    }

    /deep/ .el-radio__label {
        padding-left: 0.05rem;
    }
}

/deep/ .Export-Item-Radio-Download {
    display: flex;
    flex-direction: column;

    .el-radio {
        display: flex;
        color: black;
        width: 230px;
        margin-right: 0;
        margin-top: 5px;
        padding-left: 5px;
        line-height: 3;
        margin-bottom: 10px;
        margin-left: 20px;

        .el-radio__input {
            display: none;
        }

        .el-radio__label {
            opacity: 1;
            width: 210px;
            padding-left: 15px;
            line-height: 2.5;
            font-size: 14px !important;
            box-shadow: 0px 3px 10px rgba(221, 221, 221, 0.9);
            border-radius: 25px;

            .el-icon-upload:before {
                font-size: 20px;
                padding-right: 10px;
                position: relative;
                top: 1px;
            }
        }

        .checked {
            position: absolute;
            top: 0;
            right: 0;
            width: 12px;
            height: 12px;
        }
    }
}

.Item-File {
    display: flex;
    margin-top: 10px;
    justify-content: center;
}

.planNumber /deep/ .el-input__prefix {
    top: 6px;
}

.myInquirySearcher {
    .centerBox {
        .centerBox-top {
            display: flex;

            > div {
                margin-right: 0.15rem;
            }

            .searchBtn {
                white-space: nowrap;
                line-height: 0.35rem;
                text-shadow: 2px 2px 5px #999;
                color: #f54402;
                font-size: 0.14rem;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .el-input, .el-autocomplete {
            height: 0.4rem;
        }

        /deep/ .el-input__inner {
            padding-left: 0.26rem !important;
            border-radius: 20px;
            height: 0.35rem;
        }

        .centerBox-button {
            display: flex;
            justify-content: space-between;

            .centerBox-leftBox {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                width: 6rem;

                li {
                    display: inline-block;
                    width: 0.25rem;
                    height: 0.25rem;
                    border-radius: 50%;
                    border: 0.01rem solid #dcdcdc;
                    line-height: 0.25rem;
                    text-align: center;
                    cursor: pointer;
                    margin: 0.1rem 0rem 0.1rem 0.1rem;
                }

                li:first-of-type {
                    width: 0.35rem;
                    border-radius: inherit;
                }

                .checkedLi {
                    background: #db4e1a;
                    color: #fff;
                    border: none;
                }

                .btnList {
                    padding-left: 0.13rem;

                    .btn {
                        font-size: 0.12rem;
                        margin-right: 0.1rem;
                        cursor: pointer;
                    }

                    .checkSpan {
                        color: #da4e1a;
                    }
                }
            }

            .centerBox-rightBox {
                display: flex;
                align-items: center;

                .card {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .num {
                        color: #000;
                        font-size: 0.35rem;
                    }

                    .tag {
                        text-align: center;
                    }
                }
            }
        }
    }
}

.product_body::-webkit-scrollbar {
    display: none; /* 移动端、pad 上Safari，Chrome，隐藏滚动条 */
}

.product_body {
    overflow-x: hidden;
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: #fff;
    overflow-y: scroll;
    padding: 0 0.1rem;
    top: 1.8rem;
    scrollbar-width: none; /* Firefox隐藏滚动条 */
    -ms-overflow-style: none; /* Internet Explorer 10+隐藏滚动条 */
    .loading {
        height: 40px;
        text-align: center;
        font-size: 24px;
    }

    .noMore {
        height: 40px;
        text-align: center;
        font-size: 14px;
        color: #a8a8a8;
        line-height: 40px;
    }

    .program_list {
        border: 1px solid #E65019;
        padding: 0 0.1rem;
    }
}
</style>